/**
 * 입력창 프리셋 — TextField sx 에 넣어 OutlinedInput 모양을 통일한다.
 * 참고: 입력창의 전역 기본값(테두리 색, 포커스 색, placeholder 크기)은
 * muiTheme.js 의 MuiOutlinedInput styleOverrides 가 담당한다.
 * 여기는 화면에서 추가로 골라 쓰는 변형만 둔다.
 */
export const createInputPresets = (tokens) => ({
    // 기본 외곽선 입력창 — radius 만 살짝 키워 카드 톤과 맞춘다.
    outlined: {
        "& .MuiOutlinedInput-root": { borderRadius: 1.0 },   // 12px — 기본(6px)보다 부드러운 모서리
    },
});
